import React from "react";
import { IAuthService } from "../authentication/AuthService";
import { AccountInfo } from "@azure/msal-browser";

export type Auth = {
  isAuthenticated: boolean;
  authService: IAuthService;
  account: AccountInfo | null;
};

const AuthContext = React.createContext<Auth>(undefined!);

export default AuthContext;
